import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import placeholderImage from '../../assets/files-empty.png';

const LessonResourcesDisplay = ({ resources, backgroundMode = 'light' }) => {
    const theme = useTheme();

    return (
        resources?.length > 0 ? (
            <Box
                sx={{
                    width: '100%',
                    overflowY: 'auto',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: theme.customSpacing['2xl'],
                }}
            >
                {resources.map((resource, index) => {
                    return (
                        <Box
                            sx={{
                                borderRadius: theme.shape.radius.md,
                                width: '100%',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {resource.resource_type.includes('image') && (
                                <img
                                    src={resource.resource}
                                    alt='Content'
                                    style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: theme.shape.radius.md }}
                                />
                            )}
                            {resource.resource_type.includes('pdf') && (
                                <iframe
                                    title={`resource${resource.order_sequence}`}
                                    src={resource.resource}
                                    type='application/pdf'
                                    width='100%'
                                    height='500px'
                                    style={{ border: 'none', borderRadius: theme.shape.radius.md }}
                                />
                            )}
                            {resource.resource_type.includes('video') && (
                                <video controls width='100%'>
                                    <source
                                        src={resource.resource}
                                        type={resource.resource_type}
                                    />
                                    Your browser does not support the video tag.
                                </video>
                            )}
                        </Box>
                    )
                })}
            </Box>
        ) : (
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    flexBasis: 'auto',
                    gap: theme.customSpacing.md,
                }}
            >
                <Box
                    sx={{
                        maxWidth: '50%',
                        flexGrow: 0,
                        flexShrink: 0,
                        justifyContent: 'center',
                        gap: theme.customSpacing['2xl'],
                    }}
                >
                    <img
                        src={placeholderImage}
                        alt='No resources yet'
                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                    />
                </Box>
                <Typography sx={{
                    fontSize: theme.typography.textXL.fontSize,
                    lineHeight: theme.typography.textXL.lineHeight,
                    color: backgroundMode === 'light' ? theme.palette.text.secondary : theme.palette.text.gray,
                    fontWeight: theme.typography.fontWeightMedium,
                }}>
                    No resources yet
                </Typography>
                <Typography sx={{
                    fontSize: theme.typography.textMD.fontSize,
                    lineHeight: theme.typography.textMD.lineHeight,
                    color: theme.palette.text.placeholder,
                    fontWeight: theme.typography.fontWeightRegular,
                }}>
                    You don’t have any resources here right now. Once they’re added, you’ll see them listed in this menu.
                </Typography>
            </Box>
        )
    )
}

export default LessonResourcesDisplay;